import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type ConfigurationCriteriaProductsRecapHeaderProps = {
  totalSkus: number;
  validSkus: number;
  invalidSkus: number;
};

export function ConfigurationCriteriaProductsRecapHeader({
  totalSkus,
  validSkus,
  invalidSkus,
}: ConfigurationCriteriaProductsRecapHeaderProps): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <div className='grid grid-cols-3 gap-4 rounded-lg bg-secondary-default p-4 dark:bg-layout'>
      <div className='text-center'>
        <div className='font-bold text-2xl text-secondary-foreground'>
          {totalSkus}
        </div>
        <div className='text-layout-foreground-secondary text-sm'>
          {t('Total')}
        </div>
      </div>
      <div className='text-center'>
        <div className='font-bold text-2xl text-success-default'>
          {validSkus}
        </div>
        <div className='text-layout-foreground-secondary text-sm'>
          {t('Valid')}
        </div>
      </div>
      <div className='text-center'>
        <div className='font-bold text-2xl text-error-default'>
          {invalidSkus}
        </div>
        <div className='text-layout-foreground-secondary text-sm'>
          {t('Invalid')}
        </div>
      </div>
    </div>
  );
}
